import React from "react";
import { RenderContact } from "../Components";

function Contact() {
  return <RenderContact />;
}

export { Contact };
